<template>
  <div :class="{ desktop: $isDesktop }">
    <ul
      :class="{ filtered: modelValue, desktop: $isDesktop }"
      class="ratings-distribution"
    >
      <li v-for="(rating, index) of distribution" :key="index">
        <ratings-distribution-bar
          :rating="rating"
          :selected="isSelected(rating.rate)"
          @click="rating.percent > 0 && $emit('input', rating.rate)"
        />
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import type { ReviewsDistribution } from '../types'

@Component
class PuRatingsDistribution extends Vue {
  @Prop({ required: true })
  modelValue: number | null

  @Prop({ required: true })
  distribution: ReviewsDistribution

  isSelected(rate) {
    return rate === this.modelValue
  }
}

export default toNative(PuRatingsDistribution)
</script>

<style scoped>
div {
  margin: 0.85em 1em 1em;
  padding: 0.5em 0;
  border-bottom: 1px solid var(--colour-page-background);
  border-top: 1px solid var(--colour-page-background);
}

ul {
  align-items: center;
  background-color: white;
  display: flex;
  justify-content: space-evenly;
  list-style: none;
  padding: 0;
  margin: 0;
}

.filtered a:not(.active) {
  filter: opacity(0.75) grayscale(1);
}

/* desktop & tablet */
div.desktop {
  margin: 0;
  padding: 0;
  border: none;
}

ul.desktop {
  justify-content: flex-start;
  padding-left: 0;
  margin-bottom: 1em;
}

ul.desktop li {
  cursor: pointer;
}

.ratings-distribution.desktop :deep(.graph-bar) {
  min-width: 1.2em;
}

.ratings-distribution.desktop :deep(.rating-bar) {
  padding: 0.2em;
  margin: 0 0.2em 0 0;
}
</style>
